const AUTH_STORAGE_KEY = 'cobli-auth';

const getOpenTelemetryBaggageHttpHeaders = (): { [key: string]: string } => {
  let numberOfDevices: number | undefined;
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as { state?: { userData?: { userAttributes?: { numberOfDevices?: number } } } };
      numberOfDevices = parsed.state?.userData?.userAttributes?.numberOfDevices;
    }
  } catch {}

  if (numberOfDevices == null) return {};
  return { 'ot-baggage-cobli-fleet-num-devices': numberOfDevices.toString() };
};

export { getOpenTelemetryBaggageHttpHeaders };
